module.exports = __webpack_public_path__ + "media/images/avatar-ac6c2e19b6f02f2f3471172e919362d4.svg";